import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  fetchApartmentsListingsData,
  getapartmentdetails,
} from "./DataServices/ApartmentsListingsDataServices";
import { IListing } from "./Home";
import { IAutomaticResponseHistory } from "./Models";
import { fetchAutomaticResponseHistory } from "./DataServices/AutomaticResponsesDataServices";

import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import {
  GetAllUnreadEmails,
  GetFilteredGroupDetails,
} from "./DataServices/UnprocessedEmailService";
import { StyledDataGrid } from "./index.style";
import "react-datepicker/dist/react-datepicker.css";
import Loading from "./Loading";

type GridData = {
  id: string;
  firstname: string;
  email: string;
  threadSize: number;
  lastEmailOTime: string;
  Type: string;
};
const DashBoard = () => {
  const [listed, setListed] = useState(true);
  const [listings, setListings] = useState<IListing[]>([]);
  const [last24hr, setLast24hr] = useState(0);
  const [last24hrConfirmed, setLast24hrConfirmed] = useState(0);
  const [AutomaticResponseHistoryList, setAutomaticResponseHistoryList] =
    useState<IAutomaticResponseHistory[]>([]);
  const [unreadEmails, setUnreadEmails] = useState(0);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState<GridData[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [selectedApartmentName, setSelectedAparmtnetName] = useState<string[]>(
    []
  );
  const [selectedBuildingName, setSelectedBuildingName] = useState<string[]>(
    []
  );
  const [isOpenApName, setIsOpenApName] = useState(false);
  const [isOpenBName, setIsOpenBName] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const [apartmentName, setApartmentName] = useState([]);
  const [buildingName, setBuildingName] = useState([]);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const [rowCount, setRowCount] = useState(0);

  const toggleDropdownApName = () => setIsOpenApName(!isOpenApName);

  const toggleDropdownBName = () => setIsOpenBName(!isOpenBName);
  const handleCheckboxChange = (name: number) => {
    setSelectedItems((prev) =>
      prev.includes(name)
        ? prev.filter((item) => item !== name)
        : [...prev, name]
    );
  };

  const handleCheckboxChangeApartmentName = (name: string) => {
    setSelectedAparmtnetName((prev) =>
      prev.includes(name)
        ? prev.filter((item) => item !== name)
        : [...prev, name]
    );
  };
  const handleCheckboxChangeBuildingName = (name: string) => {
    setSelectedBuildingName((prev) =>
      prev.includes(name)
        ? prev.filter((item) => item !== name)
        : [...prev, name]
    );
  };

  useEffect(() => {
    const apartmentandlisting = async () => {
      const data = await getapartmentdetails();

      const uniqueApartmentTitles = data.reduce((acc: any, item: any) => {
        const trimmedTitle = item.title.trim();
        if (!acc.includes(trimmedTitle)) {
          acc.push(trimmedTitle);
        }
        return acc;
      }, []);

      const uniqueBuildingTitles = data.reduce((acc: any, item: any) => {
        const trimmedTitle = item.building.trim();
        if (!acc.includes(trimmedTitle)) {
          acc.push(trimmedTitle);
        }
        return acc;
      }, []);

      setBuildingName(uniqueBuildingTitles);
      setApartmentName(uniqueApartmentTitles);
    };

    apartmentandlisting();
  }, []);

  const ApartmentSize = [1, 2, 3, 4];

  const ApartmentName = [
    "apartment 1",
    "Emerald Heights",
    "Maplewood Towers",
    "Oceanview Apartments",
  ];

  const BuildingName = [
    "building 1",
    "Grand Vista",
    "Pearl Heights",
    "Titanium Square",
  ];

  const columns = [
    {
      field: "firstName",
      headerName: "Group Name",
      minWidth: 100,
      flex: 0.5,
      editable: true,
    },
    // { field: "lastName", headerName: "Last Name", width: 150, editable: true },
    { field: "email", headerName: "Email", minWidth: 150, flex: 1, editable: true },

    {
      field: "groupSize",
      headerName: "Size",
      width: 80,
      editable: true,
    },
    {
      field: "threadSize",
      headerName: "Thread",
      width: 80,
      editable: true,
      renderCell: (params: any) => (loading ? <Loading /> : params.value),
    },

    {
      field: "status",
      headerName: "Appoitment",
      minWidth: 150,
      flex: 1,
      editable: true,
    },
    {
      field: "lastEmailStatus",
      headerName: "Status",
      width: 70,
      editable: true,
      renderCell: (params: any) =>
        loading ? (
          ""
        ) : params.value === "Read" ? (
          <MarkEmailReadIcon className="text-gray-500" />
        ) : (
          <MarkEmailUnreadIcon className="text-gray-800" />
        ),
    },
    {
      field: "isStarred",
      headerName: "Stared",
      width: 80,
      editable: true,
      type: loading ? "string" : "boolean",
    },
    {
      field: "latestEmailTime",
      headerName: "Latest Email",
      minWidth: 120,
      flex: 0.5,
      editable: true,
      type: "string",
      renderCell: (params: any) => {
        const { lastEmailInTime, lastEmailOutTime } = params.row;

        if (!lastEmailInTime && !lastEmailOutTime) return loading ? "" : "N/A"; // If both are missing

        const inTime = lastEmailInTime ? new Date(lastEmailInTime) : null;
        const outTime = lastEmailOutTime ? new Date(lastEmailOutTime) : null;

        let latestTime = inTime;
        let type = "in"; // Default to incoming

        if (outTime && (!inTime || outTime > inTime)) {
          latestTime = outTime;
          type = "out";
        }

        if (!latestTime) return "N/A"; // Safety check

        const now = new Date();
        const diffMs = now.getTime() - latestTime.getTime();
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

        let displayTime;
        if (diffHours < 24) {
          displayTime = `${diffHours}h ago`;
        } else {
          displayTime = `${Math.floor(diffHours / 24)} days ago`;
        }
        return loading ? (
          <></>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ color: "black", fontWeight: "bold" }}>
              {displayTime}
            </span>
            {type === "in" ? (
              <CallReceivedIcon style={{ color: "blue" }} />
            ) : (
              <CallMadeIcon style={{ color: "green" }} />
            )}
          </div>
        );
      },
    },
  ] as const;

  useEffect(() => {
    async function fetchData() {
      // setLoading(true);
      try {
        const data = await fetchApartmentsListingsData(listed);
        setListings(data);

        // setLoading(false);
      } catch (error) {
        // setLoading(false);
        console.error("Error fetching data:", error);
        // You can handle the error state here if needed
      }
    }
    fetchData();
  }, [listed]);

  useEffect(() => {
    const fetchCountUnreadEmails = async () => {
      try {
        const data = await GetAllUnreadEmails();
        setUnreadEmails(data);
      } catch {
        console.log("error while fetching unread emails");
      }
    };
    fetchCountUnreadEmails();
  }, []);



  useEffect(() => {
    const getFilteredDetails = async () => {
      const loadingData: GridData[] = [
        {
          id: "0",
          firstname: "",
          email: "",
          threadSize: -1,
          lastEmailOTime: "",
          Type: "",
        },
      ];
      setGridData(loadingData);
      setLoading(true);
      try {
        const data = await GetFilteredGroupDetails(
          {
            SelectedApartmentSizes: selectedItems,
            selectedApartmentNames: selectedApartmentName,
            selectedBuildingNames: selectedBuildingName,
          },
          pageNumber,
          pageSize
        );
        setGridData(data.items);
        setRowCount(data.totalCount ?? data.items?.length ?? 0);
        setLoading(false);
      } catch (error) {
        console.error("Error getting filtered data:", error);
        setGridData([]);
        setLoading(false);
      }
    };
    getFilteredDetails();
  }, [
    selectedApartmentName,
    selectedBuildingName,
    selectedItems,
    pageNumber,
    pageSize,
  ]);

  useEffect(() => {
    const countLast24HrsEmails = async () => {
      const last24HrsData = await fetchAutomaticResponseHistory(
        "All",
        true,
        0,
        1
      );
      const last24HrsConfirmedData = await fetchAutomaticResponseHistory(
        "Confirmed",
        true,
        0,
        1
      );
      setLast24hrConfirmed(
        last24HrsConfirmedData.totalCount ??
          (last24HrsConfirmedData.items?.length || 0)
      );
      setLast24hr(
        last24HrsData.totalCount ?? (last24HrsData.items?.length || 0)
      );
    };

    countLast24HrsEmails(); // Call the function inside useEffect
  }, [AutomaticResponseHistoryList]); // Add dependencies

  return (
    <div className="mt-16">
      <div className="w-full flex flex-wrap gap-4 p-4">
        <Link
          to="/listing"
          className="block w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)]"
        >
          <div className="bg-gray-100 h-40 md:h-48 border-2 b-gray-500 flex flex-col items-center justify-center text-black rounded-lg">
            <div className="text-sm text-black font-bold">Open Apartments</div>
            <div className="font-bold text-black text-5xl md:text-6xl">
              {listings.length}
            </div>
          </div>
        </Link>

        <Link
          to="/AutomaticResponseHistory?Last24Hrs=true&IsConfirmed=false"
          className="block w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)]"
        >
          <div className="bg-gray-100 h-40 md:h-48 border-2 b-gray-500 flex flex-col items-center justify-center text-black rounded-lg">
            <div className="text-sm text-black font-bold text-center px-2">
              Automatic Responses Last 24Hours
            </div>
            <div className="font-bold text-black text-5xl md:text-6xl">
              {last24hr}
            </div>
          </div>
        </Link>
        <Link
          to="/AutomaticResponseHistory?Last24Hrs=true&IsConfirmed=true"
          className="block w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)]"
        >
          <div className="bg-gray-100 h-40 md:h-48 border-2 b-gray-500 flex flex-col items-center justify-center text-black rounded-lg">
            <div className="text-sm text-black font-bold text-center px-2">
              Appointments Booked Last 24hours
            </div>
            <div className="font-bold text-black text-5xl md:text-6xl">
              {last24hrConfirmed}
            </div>
          </div>
        </Link>
        <div className="w-full sm:w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)] bg-gray-100 h-40 md:h-48 border-2 b-gray-500 flex flex-col items-center justify-center text-black rounded-lg">
          <div className="text-sm text-black font-bold">Unread e-mails</div>
          <div className="font-bold text-black text-5xl md:text-6xl">
            {unreadEmails}
          </div>
        </div>

      </div>
      <div className="flex flex-col md:flex-row h-full m-4 border rounded">
        <div className="w-full md:w-52 md:min-h-[28rem] border-b md:border-b-0 md:border-r p-4">
          <h2 className="text-lg font-semibold mb-4">Filters</h2>
          {/* Apartment Size Filter */}
          <div className="relative">
            <button
              onClick={toggleDropdown}
              className="whitespace-nowrap inline-flex items-center p-2 text-sm font-medium text-black  rounded-lg"
            >
              Apartment Size{" "}
              <svg
                className="w-2.5 h-2.5 ml-2"
                aria-hidden="true"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1l4 4 4-4"
                />
              </svg>
            </button>
            {isOpen && (
              <div className="absolute min-w-max  w-full top-6 -right-6 z-10 bg-white rounded border shadow-sm mt-2">
                <ul className="overflow-y-auto max-h-48 text-sm text-gray-700">
                  {ApartmentSize.map((user) => (
                    <li key={user}>
                      <div className="flex items-center p-2 rounded-sm hover:bg-gray-100">
                        <input
                          type="checkbox"
                          id={user.toString()}
                          checked={selectedItems.includes(user)}
                          onChange={() => handleCheckboxChange(user)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm"
                        />
                        <label
                          htmlFor={user.toString()}
                          className="w-full ml-2 text-sm font-medium text-gray-900 rounded-sm"
                        >
                          {user}
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          {/* Apartment Name Filter */}
          <div className="relative">
            <button
              onClick={toggleDropdownApName}
              className="whitespace-nowrap inline-flex items-center p-2 text-sm font-medium text-gray-900  rounded-lg"
            >
              Apartment Name{" "}
              <svg
                className="w-2.5 h-2.5 ml-2"
                aria-hidden="true"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1l4 4 4-4"
                />
              </svg>
            </button>
            {isOpenApName && (
              <div className="absolute min-w-max  w-full top-6 -right-6 z-10 bg-white rounded border shadow-sm mt-2">
                <ul className="overflow-y-auto max-h-48 text-sm text-gray-700">
                  {apartmentName.map((user) => (
                    <li key={user}>
                      <div className="flex items-center p-2 rounded-sm hover:bg-gray-100">
                        <input
                          type="checkbox"
                          id={user}
                          checked={selectedApartmentName.includes(user)}
                          onChange={() =>
                            handleCheckboxChangeApartmentName(user)
                          }
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm"
                        />
                        <label
                          htmlFor={user}
                          className="w-full ml-2 pr-2 text-sm font-medium text-gray-900 rounded-sm"
                        >
                          {user}
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          {/* Building Name Filter */}
          <div className="relative">
            <button
              onClick={toggleDropdownBName}
              className="whitespace-nowrap inline-flex items-center p-2 text-sm font-medium text-gray-900"
            >
              Building Name{" "}
              <svg
                className="w-2.5 h-2.5 ml-2"
                aria-hidden="true"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1l4 4 4-4"
                />
              </svg>
            </button>
            {isOpenBName && (
              <div className="absolute min-w-max  w-full top-6 -right-6 z-10 bg-white rounded border shadow-sm mt-2">
                <ul className="overflow-y-auto max-h-48 text-sm text-gray-700">
                  {buildingName.map((user) => (
                    <li key={user}>
                      <div className="flex items-center p-2 rounded-sm hover:bg-gray-100">
                        <input
                          type="checkbox"
                          id={user}
                          checked={selectedBuildingName.includes(user)}
                          onChange={() =>
                            handleCheckboxChangeBuildingName(user)
                          }
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm"
                        />
                        <label
                          htmlFor={user}
                          className="w-full ml-2 pr-2 text-sm font-medium text-gray-900 rounded-sm"
                        >
                          {user}
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <div>
            <StyledDataGrid
              className=""
              getRowClassName={(params) =>
                "whitespace-nowrap py-4 text-lg text-gray-700 grid-row transition-all duration-300"
              }
              sx={{
                ".MuiDataGrid-withBorderColor": {
                  outline: "none !important",
                },
                height: "auto",

                ".MuiDataGrid-columnHeaders": {
                  color: "#1f2937",
                  alignSelf: "right",
                },
                ".MuiDataGrid-cell": {
                  fontSize: "0.75rem",
                  fontWeight: "500",
                  padding: "8px 8px",
                  color: "#4b5563",
                },
                ".MuiDataGrid-row": {
                  padding: "0px 0px",
                  "&:hover": {
                    backgroundColor: "#fff !important",
                  },
                  transition: "background-color 0.3s ease",
                },
                ".MuiDataGrid-footerContainer": {
                  backgroundColor: "#f3f4f6",
                },
              }}
              getRowHeight={() => "auto"}
              rows={gridData}
              getRowId={(row) => row.id}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 6,
                  },
                },
              }}
              paginationMode="server"
              rowCount={rowCount}
              paginationModel={{ page: pageNumber, pageSize }}
              onPaginationModelChange={(model) => {
                setPageNumber(model.page);
                setPageSize(model.pageSize);
              }}
              pageSizeOptions={[2, 4, 6, 8, 10]}
              disableRowSelectionOnClick={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoard;
